// AUTO-GENERATED by scripts/generate-avatar-icons.ts — do not edit by hand.
// Run `npm run generate:avatar-icons` to regenerate.
import { IconType } from 'react-icons';
import {
  GiAmericanFootballBall,
  GiAmericanFootballHelmet,
  GiAnchor,
  GiBaseballBat,
  GiBaseballGlove,
  GiBasketballBall,
  GiBasketballJersey,
  GiBearFace,
  GiBeard,
  GiBigWave,
  GiBowlingPin,
  GiBoxingGlove,
  GiBrain,
  GiBroadsword,
  GiCampfire,
  GiCat,
  GiChessKing,
  GiChessKnight,
  GiChessQueen,
  GiCompanionCube,
  GiCompass,
  GiCrossedSwords,
  GiCrown,
  GiCube,
  GiDiamonds,
  GiDragonHead,
  GiEagleHead,
  GiEyeball,
  GiFire,
  GiFox,
  GiFoxHead,
  GiGems,
  GiGhost,
  GiGuitar,
  GiHearts,
  GiHiking,
  GiHockey,
  GiKing,
  GiLion,
  GiMapleLeaf,
  GiMedal,
  GiMoon,
  GiMountainClimbing,
  GiMuscleUp,
  GiMusicalNotes,
  GiNinjaHead,
  GiNinjaMask,
  GiOakLeaf,
  GiOwl,
  GiPalmTree,
  GiPanda,
  GiPerson,
  GiPineTree,
  GiPodiumWinner,
  GiPolarBear,
  GiQueenCrown,
  GiRobotAntennas,
  GiRobotHelmet,
  GiRocket,
  GiRoundShield,
  GiRoundStar,
  GiRunningShoe,
  GiSeaDragon,
  GiSharkFin,
  GiShield,
  GiSkullCrossedBones,
  GiSnowboard,
  GiSnowflake1,
  GiSnowman,
  GiSoccerBall,
  GiStopwatch,
  GiSun,
  GiSunglasses,
  GiTennisBall,
  GiTennisRacket,
  GiTiger,
  GiTigerHead,
  GiTrophy,
  GiTrophyCup,
  GiVikingHead,
  GiVikingHelmet,
  GiWaves,
  GiWeight,
  GiWeightLiftingUp,
  GiWhistle,
  GiWizardFace,
  GiWolfHead,
} from 'react-icons/gi';

/** Stable, type-safe keys for the curated game-icon avatar set. */
export enum JcAvatarIcon {
  GiAmericanFootballBall = 'GiAmericanFootballBall',
  GiAmericanFootballHelmet = 'GiAmericanFootballHelmet',
  GiAnchor = 'GiAnchor',
  GiBaseballBat = 'GiBaseballBat',
  GiBaseballGlove = 'GiBaseballGlove',
  GiBasketballBall = 'GiBasketballBall',
  GiBasketballJersey = 'GiBasketballJersey',
  GiBearFace = 'GiBearFace',
  GiBeard = 'GiBeard',
  GiBigWave = 'GiBigWave',
  GiBowlingPin = 'GiBowlingPin',
  GiBoxingGlove = 'GiBoxingGlove',
  GiBrain = 'GiBrain',
  GiBroadsword = 'GiBroadsword',
  GiCampfire = 'GiCampfire',
  GiCat = 'GiCat',
  GiChessKing = 'GiChessKing',
  GiChessKnight = 'GiChessKnight',
  GiChessQueen = 'GiChessQueen',
  GiCompanionCube = 'GiCompanionCube',
  GiCompass = 'GiCompass',
  GiCrossedSwords = 'GiCrossedSwords',
  GiCrown = 'GiCrown',
  GiCube = 'GiCube',
  GiDiamonds = 'GiDiamonds',
  GiDragonHead = 'GiDragonHead',
  GiEagleHead = 'GiEagleHead',
  GiEyeball = 'GiEyeball',
  GiFire = 'GiFire',
  GiFox = 'GiFox',
  GiFoxHead = 'GiFoxHead',
  GiGems = 'GiGems',
  GiGhost = 'GiGhost',
  GiGuitar = 'GiGuitar',
  GiHearts = 'GiHearts',
  GiHiking = 'GiHiking',
  GiHockey = 'GiHockey',
  GiKing = 'GiKing',
  GiLion = 'GiLion',
  GiMapleLeaf = 'GiMapleLeaf',
  GiMedal = 'GiMedal',
  GiMoon = 'GiMoon',
  GiMountainClimbing = 'GiMountainClimbing',
  GiMuscleUp = 'GiMuscleUp',
  GiMusicalNotes = 'GiMusicalNotes',
  GiNinjaHead = 'GiNinjaHead',
  GiNinjaMask = 'GiNinjaMask',
  GiOakLeaf = 'GiOakLeaf',
  GiOwl = 'GiOwl',
  GiPalmTree = 'GiPalmTree',
  GiPanda = 'GiPanda',
  GiPerson = 'GiPerson',
  GiPineTree = 'GiPineTree',
  GiPodiumWinner = 'GiPodiumWinner',
  GiPolarBear = 'GiPolarBear',
  GiQueenCrown = 'GiQueenCrown',
  GiRobotAntennas = 'GiRobotAntennas',
  GiRobotHelmet = 'GiRobotHelmet',
  GiRocket = 'GiRocket',
  GiRoundShield = 'GiRoundShield',
  GiRoundStar = 'GiRoundStar',
  GiRunningShoe = 'GiRunningShoe',
  GiSeaDragon = 'GiSeaDragon',
  GiSharkFin = 'GiSharkFin',
  GiShield = 'GiShield',
  GiSkullCrossedBones = 'GiSkullCrossedBones',
  GiSnowboard = 'GiSnowboard',
  GiSnowflake1 = 'GiSnowflake1',
  GiSnowman = 'GiSnowman',
  GiSoccerBall = 'GiSoccerBall',
  GiStopwatch = 'GiStopwatch',
  GiSun = 'GiSun',
  GiSunglasses = 'GiSunglasses',
  GiTennisBall = 'GiTennisBall',
  GiTennisRacket = 'GiTennisRacket',
  GiTiger = 'GiTiger',
  GiTigerHead = 'GiTigerHead',
  GiTrophy = 'GiTrophy',
  GiTrophyCup = 'GiTrophyCup',
  GiVikingHead = 'GiVikingHead',
  GiVikingHelmet = 'GiVikingHelmet',
  GiWaves = 'GiWaves',
  GiWeight = 'GiWeight',
  GiWeightLiftingUp = 'GiWeightLiftingUp',
  GiWhistle = 'GiWhistle',
  GiWizardFace = 'GiWizardFace',
  GiWolfHead = 'GiWolfHead',
}

export const JC_AVATAR_ICONS: Record<JcAvatarIcon, IconType> = {
  [JcAvatarIcon.GiAmericanFootballBall]: GiAmericanFootballBall,
  [JcAvatarIcon.GiAmericanFootballHelmet]: GiAmericanFootballHelmet,
  [JcAvatarIcon.GiAnchor]: GiAnchor,
  [JcAvatarIcon.GiBaseballBat]: GiBaseballBat,
  [JcAvatarIcon.GiBaseballGlove]: GiBaseballGlove,
  [JcAvatarIcon.GiBasketballBall]: GiBasketballBall,
  [JcAvatarIcon.GiBasketballJersey]: GiBasketballJersey,
  [JcAvatarIcon.GiBearFace]: GiBearFace,
  [JcAvatarIcon.GiBeard]: GiBeard,
  [JcAvatarIcon.GiBigWave]: GiBigWave,
  [JcAvatarIcon.GiBowlingPin]: GiBowlingPin,
  [JcAvatarIcon.GiBoxingGlove]: GiBoxingGlove,
  [JcAvatarIcon.GiBrain]: GiBrain,
  [JcAvatarIcon.GiBroadsword]: GiBroadsword,
  [JcAvatarIcon.GiCampfire]: GiCampfire,
  [JcAvatarIcon.GiCat]: GiCat,
  [JcAvatarIcon.GiChessKing]: GiChessKing,
  [JcAvatarIcon.GiChessKnight]: GiChessKnight,
  [JcAvatarIcon.GiChessQueen]: GiChessQueen,
  [JcAvatarIcon.GiCompanionCube]: GiCompanionCube,
  [JcAvatarIcon.GiCompass]: GiCompass,
  [JcAvatarIcon.GiCrossedSwords]: GiCrossedSwords,
  [JcAvatarIcon.GiCrown]: GiCrown,
  [JcAvatarIcon.GiCube]: GiCube,
  [JcAvatarIcon.GiDiamonds]: GiDiamonds,
  [JcAvatarIcon.GiDragonHead]: GiDragonHead,
  [JcAvatarIcon.GiEagleHead]: GiEagleHead,
  [JcAvatarIcon.GiEyeball]: GiEyeball,
  [JcAvatarIcon.GiFire]: GiFire,
  [JcAvatarIcon.GiFox]: GiFox,
  [JcAvatarIcon.GiFoxHead]: GiFoxHead,
  [JcAvatarIcon.GiGems]: GiGems,
  [JcAvatarIcon.GiGhost]: GiGhost,
  [JcAvatarIcon.GiGuitar]: GiGuitar,
  [JcAvatarIcon.GiHearts]: GiHearts,
  [JcAvatarIcon.GiHiking]: GiHiking,
  [JcAvatarIcon.GiHockey]: GiHockey,
  [JcAvatarIcon.GiKing]: GiKing,
  [JcAvatarIcon.GiLion]: GiLion,
  [JcAvatarIcon.GiMapleLeaf]: GiMapleLeaf,
  [JcAvatarIcon.GiMedal]: GiMedal,
  [JcAvatarIcon.GiMoon]: GiMoon,
  [JcAvatarIcon.GiMountainClimbing]: GiMountainClimbing,
  [JcAvatarIcon.GiMuscleUp]: GiMuscleUp,
  [JcAvatarIcon.GiMusicalNotes]: GiMusicalNotes,
  [JcAvatarIcon.GiNinjaHead]: GiNinjaHead,
  [JcAvatarIcon.GiNinjaMask]: GiNinjaMask,
  [JcAvatarIcon.GiOakLeaf]: GiOakLeaf,
  [JcAvatarIcon.GiOwl]: GiOwl,
  [JcAvatarIcon.GiPalmTree]: GiPalmTree,
  [JcAvatarIcon.GiPanda]: GiPanda,
  [JcAvatarIcon.GiPerson]: GiPerson,
  [JcAvatarIcon.GiPineTree]: GiPineTree,
  [JcAvatarIcon.GiPodiumWinner]: GiPodiumWinner,
  [JcAvatarIcon.GiPolarBear]: GiPolarBear,
  [JcAvatarIcon.GiQueenCrown]: GiQueenCrown,
  [JcAvatarIcon.GiRobotAntennas]: GiRobotAntennas,
  [JcAvatarIcon.GiRobotHelmet]: GiRobotHelmet,
  [JcAvatarIcon.GiRocket]: GiRocket,
  [JcAvatarIcon.GiRoundShield]: GiRoundShield,
  [JcAvatarIcon.GiRoundStar]: GiRoundStar,
  [JcAvatarIcon.GiRunningShoe]: GiRunningShoe,
  [JcAvatarIcon.GiSeaDragon]: GiSeaDragon,
  [JcAvatarIcon.GiSharkFin]: GiSharkFin,
  [JcAvatarIcon.GiShield]: GiShield,
  [JcAvatarIcon.GiSkullCrossedBones]: GiSkullCrossedBones,
  [JcAvatarIcon.GiSnowboard]: GiSnowboard,
  [JcAvatarIcon.GiSnowflake1]: GiSnowflake1,
  [JcAvatarIcon.GiSnowman]: GiSnowman,
  [JcAvatarIcon.GiSoccerBall]: GiSoccerBall,
  [JcAvatarIcon.GiStopwatch]: GiStopwatch,
  [JcAvatarIcon.GiSun]: GiSun,
  [JcAvatarIcon.GiSunglasses]: GiSunglasses,
  [JcAvatarIcon.GiTennisBall]: GiTennisBall,
  [JcAvatarIcon.GiTennisRacket]: GiTennisRacket,
  [JcAvatarIcon.GiTiger]: GiTiger,
  [JcAvatarIcon.GiTigerHead]: GiTigerHead,
  [JcAvatarIcon.GiTrophy]: GiTrophy,
  [JcAvatarIcon.GiTrophyCup]: GiTrophyCup,
  [JcAvatarIcon.GiVikingHead]: GiVikingHead,
  [JcAvatarIcon.GiVikingHelmet]: GiVikingHelmet,
  [JcAvatarIcon.GiWaves]: GiWaves,
  [JcAvatarIcon.GiWeight]: GiWeight,
  [JcAvatarIcon.GiWeightLiftingUp]: GiWeightLiftingUp,
  [JcAvatarIcon.GiWhistle]: GiWhistle,
  [JcAvatarIcon.GiWizardFace]: GiWizardFace,
  [JcAvatarIcon.GiWolfHead]: GiWolfHead,
};

export const isJcAvatarIcon = (value: unknown): value is JcAvatarIcon =>
  typeof value === 'string' && value in JC_AVATAR_ICONS;
